export default "__VITE_ASSET__B6Bb8sPk__"